(function () {
    var maxNumOfChars = 120;
    var giftNoteInput = document.getElementById('gift-note');
    var characterCounter = document.getElementById("char_count");
    var checkbox = document.querySelector('[name="attributes[gift-wrapping]"]');
    var headers = new Headers({ 'Content-Type': 'application/json' });
    Shopify.Cart = Shopify.Cart || {};
    Shopify.Cart.GiftWrap = {};

    function countCharacters () {
        var numOfEnteredChars = giftNoteInput.value.length;
        var counter = maxNumOfChars - numOfEnteredChars;
        if (numOfEnteredChars > maxNumOfChars) {
            var value = giftNoteInput.value.substring(0, maxNumOfChars);
            giftNoteInput.value = value;
            counter = 0;
        }
        characterCounter.textContent = counter + " of 120";
    }

    function redirectToCart () {
        location.href = '/cart';
    }

    Shopify.Cart.GiftWrap.set = function() {
        var request = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                updates: {
                    [window.CartGiftWrapID]: 1
                },
                attributes: {
                    'gift-wrapping': true
                }
            })
        }

        fetch('/cart/update.js', request).then(redirectToCart);
    }

    Shopify.Cart.GiftWrap.remove = function() {
        var request = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                updates: {
                    [window.CartGiftWrapID]: 0
                },
                attributes: {
                    'gift-wrapping': '',
                    'gift-note': ''
                }
            })
        }

        fetch('/cart/update.js', request).then(redirectToCart);
    }


    switch (window.CartGiftAction) {
        case 'set':
            Shopify.Cart.GiftWrap.set();
        case 'remove':
            Shopify.Cart.GiftWrap.remove();
    }

    giftNoteInput && giftNoteInput.addEventListener("input", countCharacters);

    checkbox && checkbox.addEventListener("change", function(event) {
        if (event.target.checked)
            return Shopify.Cart.GiftWrap.set();

        Shopify.Cart.GiftWrap.remove();
    });

    giftNoteInput && giftNoteInput.addEventListener("change", function(evt) {
        var note = evt.target.value;

        var request = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ attributes: { 'gift-note': note } })
        };

        fetch('/cart/update.js', request);
    });
})();
